import React, { FC, memo } from 'react'
import { cn } from 'shared/utils'
import { Icon, Popover } from '@wmgtech/legato'

import { ConditionRender } from 'components'
import { AutoStoryPopoverContent, StoryInfo } from 'modules/Feed/components'

import { AutoStoryWrapperProps } from './AutoStoryWrapper.props'

import '../Story/Story.scss'
import './AutoStoryWrapper.scss'
import FollowButtonContainer from 'modulesCommon/Follow/containers/FollowButton'
import { Story } from 'components/Story'
import { useParams } from 'react-router-dom'
import { TRouterParams } from '../../../../shared/types'

const AutoStoryWrapper: FC<AutoStoryWrapperProps> = memo(
  ({
    isExpanded,
    type,
    storyRef,
    story,
    children
  }) => {
    const { id } = useParams<TRouterParams>()


    const title =
      type === 'peak'
        ? 'Peak Position Auto Story'
        : type === 'radio'
          ? 'Radio Airplay Update Auto Story'
          : 'DSP Priority Playlist Update Auto Story'

    return (
      <div className="story auto-story" ref={storyRef}>
        <Story.Container story={story}>
          <Story.Header
            actions={
              <FollowButtonContainer
                projectId={String(story.campaign.id)}
                projectName={`${story.artist.name} ${story.campaign.name}`}
                userId={story.campaign.owner_id}
              />
            }
          />
        </Story.Container>
        <div className={cn('story__body auto-story__body', { 'auto-story__body--expanded': isExpanded })}>
          <div className="story__body-info auto-story__body-container">{children}</div>
        </div>

        <StoryInfo story={story} projectId={id} isSquare />

        <div className="story__footer auto-story__footer">
          <Icon name="robot" className="story__footer-icon" />
          <span className="story__footer-auto">{title}</span>
          -&nbsp;&nbsp;This story was automatically created by the Storybot.
          <ConditionRender
            condition={type !== 'peak'}
            component={
              <Popover
                className="story__popover"
                content={<AutoStoryPopoverContent type={story.argument_type} />}
                popoverPlacement="bottom"
                title="Auto Story"
                trigger={<Icon name="circle-info" prefix="fas" className="story__footer-icon story__popover-toggler" />}
              />
            }
          />
        </div>
      </div>
    )
  }
)

export default AutoStoryWrapper
